import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import './Layout.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ComplianceStatus from '../../pages/compliance/complianceStatus/compliance_status';
import i18n from '../../i18n';
import UserManage from 'src/pages/User/UserManage';
import Notification from '../Notification/Notification';
import DashboardImplemetor from 'src/pages/DashboardImplementor/DashboardImplemetor';
import TaskUserCalender from 'src/pages/DashboardImplementor/component/TaskUserCalender';
import RiskCatalog from 'src/pages/Risk/RiskCatalog';
import CreateRiskForm from 'src/pages/Risk/CreateRisk/Create';
import UpdateRiskForm from 'src/pages/Risk/UpdateRisk/update';
import Assessment from 'src/pages/Risk/assessment/Assessment';
import AnnouncementTable from 'src/pages/Announcement/announcement';

import Rcsa from 'src/pages/RCSA/rcsa';
import CertificationsList from 'src/pages/certifications/ListCertifications';
import CreateQuestion from 'src/pages/SurveyQuestion/BankQuestions/CreateQuestion';
import CreateSurvey from 'src/pages/AllSurveys/CreateSurvey';
import Surveys from 'src/pages/SurveyQuestion/Surveys/Surveys';
import QuestionTable from 'src/pages/SurveyQuestion/BankQuestions/questionCatalog';

import ExportSurvey from 'src/pages/SurveyQuestion/Surveys/ExportSurvey';
import UpdateSurvey from 'src/pages/AllSurveys/UpdateSurvey';
import UpdateQuestion from 'src/pages/SurveyQuestion/BankQuestions/UpdateQuestion';
import PermissionPages from 'src/pages/PermissionLoginPages/PermissionPages';
import ImpactAreaTable from 'src/pages/ImpactArea/ViewImpact';
import CreateImpact from 'src/pages/ImpactArea/CreateImpact';
import UpdateImpact from 'src/pages/ImpactArea/update/updateImpact';
import Register from 'src/pages/register/Register';
import CreateFunctionPage from 'src/pages/FunctionUser/Function';
import SurvyQuestionTable from 'src/pages/AllSurveys/Surveys';
import ReplayQuestion from 'src/pages/AllSurveys/ReplayQuestion';
import QuestionControlTree from 'src/pages/QuestionControl/QuestionControlTree';
import TeamOnboarding from 'src/pages/invitationUser/inviteTeam';
import ObjectiveModal from 'src/pages/Objective/objectiveModal';
import UnifiedControlLandscape from 'src/pages/frameWork/frameWork';
import AssessmentScore from 'src/pages/frameWork/AssessmentScore';
import ProtectedRoute from '../ProtectedRoute';
import OrganizationChart from 'src/pages/OrganizationChart/OrganizationChart';
import FileManager from 'src/pages/OnBoxMessage/viewAllMessage';
import RoleBasedRoute from '../RoleBasedRoute';
import UpdateControlPage from 'src/pages/referenes/updateControl';


const ViewControl = React.lazy(() => import('../../pages/compliance/assessment/viewControl'));
const CreateCompliance = React.lazy(() => import('../../pages/compliance/createCompliance/CreateCompliance'));
const UpdateCompliance = React.lazy(() => import('../../pages/compliance/editCompliance/UpdateCompliance'));
const Compliance = React.lazy(() => import('../../pages/compliance/compliance/Compliance'));
const InformationCompliance = React.lazy(() => import('../../pages/compliance/info/informationCompliance'));
const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'));
const References = React.lazy(() => import('../../pages/referenes/references'));
const Login = React.lazy(() => import('../../pages/login/login'));

const Tickets = React.lazy(() => import('../../pages/Tickets/Tickets'));




const Main: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const location = useLocation();
    
    // Example: Set direction dynamically
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Determine if the current route is the login page
const isLoginPage = location.pathname === '/login' || location.pathname === '/register';

    const updateDirection = (lng: string) => {
        // Implement your direction update logic here
        //console.log(`Direction updated for language: ${lng}`);
    };

    const handleLanguageChange = (lng: string) => {
        updateDirection(lng);
    };

    useEffect(() => {
        i18n.on('languageChanged', handleLanguageChange);

        // Cleanup listener on component unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, []);
//console.log(userRole,"userRoleuserRoleuserRole")
    return (
        <div className={`layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            {!isLoginPage &&  <Sidebar 
              isOpen={isSidebarOpen} 
              onToggle={() => setIsSidebarOpen(!isSidebarOpen)} 
              language={i18n.language as 'en' | 'ar'} 
            />}
            <div className={`${!isLoginPage ? 'main-content' : 'main-content-login w-100'}`}>
                <ToastContainer />
                {!isLoginPage && <Header onMobileToggle={toggleSidebar}  className='w-100 z-100' />}
                <React.Suspense fallback={<div>Loading...</div>}>
                    <Routes>
              
                    <Route path="/" element={
                          <ProtectedRoute>
                            <RoleBasedRoute />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliance/info" element={
                          <ProtectedRoute>
                            <InformationCompliance />
                          </ProtectedRoute>
                        } />
                         <Route path="/announcements" element={
                          <ProtectedRoute>
                            <AnnouncementTable/>
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances" element={
                          <ProtectedRoute>
                            <Compliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/standards" element={
                          <ProtectedRoute>
                            <References />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliance-status" element={
                          <ProtectedRoute>
                            <ComplianceStatus />
                          </ProtectedRoute>
                        } />
                        <Route path="/ticket" element={
                          <ProtectedRoute>
                            <Tickets />
                          </ProtectedRoute>
                        } />
    <Route path="/organization-chart" element={
                          <ProtectedRoute>
                            <OrganizationChart/>
                          </ProtectedRoute>
                        } /> 

                          <Route path="/oneboxMessage" element={
                          <ProtectedRoute>
                           <FileManager />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliance/create" element={
                          <ProtectedRoute>
                            <CreateCompliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances/edit/:id" element={
                          <ProtectedRoute>
                            <UpdateCompliance />
                          </ProtectedRoute>
                        } />
                        <Route path="/certifications" element={
                          <ProtectedRoute>
                            <CertificationsList/>
                          </ProtectedRoute>
                        } />

                        <Route path="/compliances/status/:id" element={
                          <ProtectedRoute>
                            <ComplianceStatus/>
                          </ProtectedRoute>
                        } />
                        <Route path="/compliances/view-control/:id/:fieldId/:subFieldId" element={
                          <ProtectedRoute>
                            <ViewControl />
                          </ProtectedRoute>
                        } />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/function" element={
                          <ProtectedRoute>
                            <CreateFunctionPage/>
                          </ProtectedRoute>
                        } />
                        <Route path="/QuestionControlTree" element={
                          <ProtectedRoute>
                            <QuestionControlTree/>
                          </ProtectedRoute>
                        } />
                        <Route path="/createsurvey" element={
                          <ProtectedRoute>
                            <CreateSurvey/>
                          </ProtectedRoute>
                        } /> 

                   <Route path="/viewsurvey" element={
                     <ProtectedRoute>
                       <SurvyQuestionTable/>
                     </ProtectedRoute>
                   } /> 
                      <Route path="/updatesurvey/:id" element={
                        <ProtectedRoute>
                          <UpdateSurvey/>
                        </ProtectedRoute>
                      } />
                        <Route path="/user" element={
                          <ProtectedRoute>
                            <UserManage/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/notification" element={
                          <ProtectedRoute>
                            <Notification/>
                          </ProtectedRoute>
                        } /> 
           <Route path="/team-onboarding" element={
             <ProtectedRoute>
               <TeamOnboarding />
             </ProtectedRoute>
           } />

                        <Route path="/exportsurvey/:id" element={
                          <ProtectedRoute>
                            <ExportSurvey/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/assessmentsurvey/:id" element={
                          <ProtectedRoute>
                            <ReplayQuestion/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/objective" element={
                          <ProtectedRoute>
                            <ObjectiveModal/>
                          </ProtectedRoute>
                        } /> 
                        <Route path="/frameWork" element={
                          <ProtectedRoute>
                            <UnifiedControlLandscape/>
                          </ProtectedRoute>
                        } />
                        <Route path="/assessment-score" element={
                          <ProtectedRoute>
                            <AssessmentScore/>
                          </ProtectedRoute>
                        } /> 

                     
                       <Route path="/updatecontrol/:id" element={
                            // <ProtectedRoute>
                             <UpdateControlPage/>
                            // </ProtectedRoute>
                        } /> 

                        <Route path="/viewTaskCalender" element={
                          <ProtectedRoute>
                            <TaskUserCalender/>
                          </ProtectedRoute>
                        } /> 
                        {/*<Route path="/riskCatalog" element={<RiskCatalog/>} /> 
                        <Route path="/createRisk" element={<CreateRiskForm/>} /> 
                        <Route path="/updateRisk/:id" element={<UpdateRiskForm/>} /> 
                        <Route path="/assessment/:id" element={<Assessment/>} /> 
                        <Route path="/rcsa" element={<Rcsa/>} /> 
                        <Route path="/createQuestion" element={<CreateQuestion/>} /> 
                        <Route path="/create-survey" element={<CreateSurvey/>} /> 
                        <Route path="/export-survey/:id" element={<ExportSurvey/>} /> 
                        <Route path="/surveys" element={<Surveys/>} /> 
                        <Route path="/bankQuestions" element={<QuestionTable/>} /> 
                        <Route path="/updateQuestion/:id" element={<UpdateQuestion/>} /> */}
                        <Route path="/permission" element={
                          <ProtectedRoute>
                            <PermissionPages/>
                          </ProtectedRoute>
                        } /> 
                        {/*<Route path="/impactArea" element={<ImpactAreaTable/>} /> 
                        <Route path="/createImpact" element={<CreateImpact/>} /> 
                        <Route path="/updateImpacted/:id" element={<UpdateImpact/>} /> 


                        <Route path="/assessment-survey/:id" element={<ReplayQuestion/>} /> 
                        <Route path="/updateSurvey/:id" element={<UpdateSurvey/>} /> */}










                        

                    </Routes>
                </React.Suspense>
            </div>
        </div>
    );
};

export default Main;















